var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinDrop24Px(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.083 31.667V34.834H7.91602V31.667H30.083ZM18.999 3.16699C24.2399 3.16699 28.499 7.42616 28.499 12.667C28.499 19.792 18.999 30.084 18.999 30.084C18.999 30.084 9.49902 19.792 9.49902 12.667C9.49902 7.42627 13.7583 3.16717 18.999 3.16699ZM18.999 9.5C17.2575 9.50018 15.833 10.9254 15.833 12.667C15.833 14.4086 17.2575 15.8338 18.999 15.834C20.7565 15.834 22.166 14.4087 22.166 12.667C22.166 10.9253 20.7407 9.5 18.999 9.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinDrop24Px);
export default __webpack_public_path__ + "static/media/pin_drop_24px.0d887248b6ff18d6585d6b1e9ce56137.svg";
export { ForwardRef as ReactComponent };